module["exports"] = [
  "com",
  "com",
  "com",
  "net",
  "org",
  "it",
  "it",
  "it"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/internet/domain_suffix.js
 ** module id = 695
 ** module chunks = 0
 **/